import React from 'react';

const MaintenanceContentES = () => {
    return (
        <div className="maintenance-container">
            <img src="/assets/images/logos/logo-gsa.png" alt="Logo GSA" className="maintenance-logo" />
            <h1 className="maintenance-title">Estamos Mejorando Nuestro Sitio</h1>
            <p className="maintenance-message">
                Algunas funciones, como el inicio de sesión y el registro, pueden estar temporalmente deshabilitadas.
                Agradecemos tu comprensión y paciencia mientras trabajamos para mejorar tu experiencia.
            </p>
            <p className="maintenance-contact">
                Si necesitas asistencia urgente, contáctanos en: <a href="mailto:info@divegsa.com">info@divegsa.com</a>
            </p>
        </div>
    );
};

export default MaintenanceContentES; 